import { render } from "./StudentToOrgMatchingDataTable.vue?vue&type=template&id=ef6bad7a&scoped=true"
import script from "./StudentToOrgMatchingDataTable.vue?vue&type=script&lang=js"
export * from "./StudentToOrgMatchingDataTable.vue?vue&type=script&lang=js"

import "./StudentToOrgMatchingDataTable.vue?vue&type=style&index=0&id=ef6bad7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6bad7a"]])

export default __exports__